export default __webpack_public_path__ + "static/whatsapp (2) 1-13cddb071f3e1d7adb7f20f2286977f0.svg";